import { ListMusic } from "lucide-react";

export const QueueBar = ({ count, onPlayQueue, onClear }) => {
  if (count === 0) return null;

  return (
    <div
      className="flex items-center justify-between gap-3 rounded-2xl px-4 py-3 mb-3"
      style={{ background: "rgba(255,255,255,.05)", border: "1px solid rgba(255,255,255,.08)" }}
    >
      <div className="flex items-center gap-2 text-white/80 text-sm min-w-0">
        <ListMusic size={16} className="text-white/50 shrink-0" />
        <span className="truncate">Mi lista ({count})</span>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button onClick={onClear} className="text-xs text-white/40 hover:text-white/70 px-2 py-1.5">
          Vaciar
        </button>
        <button
          onClick={onPlayQueue}
          className="text-xs font-semibold bg-[#e0217a] text-white px-3 py-1.5 rounded-full"
        >
          Reproducir
        </button>
      </div>
    </div>
  );
};
